import { lazy } from 'react';

export const LazyHelpSupport = lazy(() => import('@/pages/HelpSupport').then(module => ({ default: module.HelpSupport })));